import { combineReducers } from 'redux';
import AdhStore from './AdhStore';
import ProStore from './ProStore';
import CopStore from './CopStore';
import SynStore from './SynStore';
import DocStore from './DocStore';
import MesStore from './MesStore';
import VoteStore from './VoteStore';

const rootReducer = combineReducers({
    AdhStore,
    ProStore,
    CopStore,
    SynStore,
    DocStore,
    MesStore,
    VoteStore,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/Reducers/index.js